import React from 'react';
import { useNavigate } from 'react-router-dom';
import backgroundVideo from '../../assets/Video/52888-471156118.mp4';

const Quote = () => {
  const navigate = useNavigate();

  return (
    <div className="relative w-full h-[600px] overflow-hidden">
      {/* Background Video */}
      <video
        className="absolute top-0 left-0 w-full h-full object-cover"
        src={backgroundVideo}
        autoPlay
        loop
        muted
        playsInline
        loading="lazy"
      />

      {/* Overlay Content */}
      <div className="absolute inset-0 bg-black/60 flex flex-col items-center justify-center text-center text-white px-4">
        <h2 className="text-4xl font-bold mb-4" style={{ color: '#e6b127' }}>
          One Partner. Every Solution.
        </h2>
        <p className="text-lg max-w-2xl mb-6">
          Labh Industries delivers complete solutions under one roof—from strategy to execution. Let us help you overcome challenges and bring your vision to reality with unmatched quality, innovation, and reliability.
        </p>
        <button
          onClick={() => navigate('/contact')}
          className="bg-[#5bc0fe] hover:bg-[#3aa7e0] text-white font-semibold px-6 py-3 rounded-xl transition duration-300"
        >
          Request a Quote
        </button>
      </div>
    </div>
  );
};

export default Quote;
